import React, { useEffect, useState } from 'react'
import { useMutation } from '@apollo/client'
import ReorderItems from './ReorderItems'
import { GET_ALL_STATUS_BY_TYPE } from '../../../../../../graphql/Catalog/Status/status'

const StatusOrderingModal = ({
  idModal,
  modal,
  setModal,
  config,
  handleOrder,
}) => {
  const [items, setItems] = useState([])

  const closeModal = () => {
    setModal(false)
    window.jQuery('#' + idModal).modal('hide')
  }

  const [getData] = useMutation(GET_ALL_STATUS_BY_TYPE)

  const handleAccept = () => {
    setModal(false)
    handleOrder({ items })
    window.jQuery('#' + idModal).modal('hide')
  }

  const processData = async () => {
    try {
      const {
        data: { getAllStatusByType },
      } = await getData({
        variables: { type: config.type },
      })

      setItems(getAllStatusByType)
    } catch (error) {}
  }

  useEffect(() => {
    if (config.type) {
      processData()
    }
  }, [config])

  return (
    <>
      {modal && (
        <div
          className="modal fade"
          data-backdrop="static"
          data-keyboard="false"
          id={idModal}
          tabIndex="-1"
          role="dialog"
          aria-labelledby={`${idModal}Title`}
          aria-hidden="true"
        >
          <div
            className={`modal-dialog modal-dialog-scrollable modal-dialog-centered modal-md`}
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{config.title}</h5>
                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  onClick={closeModal}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {items && items.length > 0 && (
                  <ReorderItems items={items} setItems={setItems} />
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-migrates mr-3"
                  style={{ fontSize: 14 }}
                  onClick={closeModal}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-migrates "
                  onClick={handleAccept}
                >
                  Guardar ordenamiento
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default StatusOrderingModal
